import React from "react";

export const ChevronLeftIcon = ({...props}) => {
  return (
    <>
      <path d="M16.1236265,23.6383098 C16.5268659,24.086862 17.2190719,24.123154 17.6675564,23.7195037 C18.1151524,23.314214 18.1504192,22.6241949 17.7487514,22.1735235 L17.7487503,22.1735235 L8.56513425,11.9695061 L17.7472476,1.82645291 C18.129642,1.40065823 18.1388683,0.709066467 17.6660526,0.280470629 C17.2177047,-0.123177598 16.525773,-0.0868167827 16.1221227,0.361666647 L16.1221227,0.361666647 L6.28033682,11.2354735 C5.90655439,11.6544332 5.90655439,12.2821886 6.28033682,12.7008063 L6.28033682,12.7008063 L16.1236265,23.6383098 Z" />
    </>
  );
};